<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>体验课上课要求</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="16">
          <!-- 第一行：反馈时间 -->
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item label="反馈时间">
              <Date-picker
                type="daterange"
                format="yyyy-MM-dd"
                placement="bottom-end"
                @on-change="dateRangeChange"
                v-model="dateRange"
                style="width: 100%;"
              ></Date-picker>
            </Form-item>
          </Col>

          <!-- 第二行：老师 ID -->
          <Col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="老师 ID" prop="tchId">
              <Input name="tchId" v-model="queryParam.tchId" placeholder="请输入老师 ID"></Input>
            </Form-item>
          </Col>

          <!-- 第三行：老师名称 -->
          <Col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="老师名称" prop="tchName">
              <Input name="tchName" placeholder="支持模糊搜索" v-model="queryParam.tchName"></Input>
            </Form-item>
          </Col>

          <!-- 第四行：反馈内容 -->
          <Col :xs="24" :sm="12" :md="8" :lg="5">
            <Form-item label="反馈内容" prop="content">
              <Input name="content" placeholder="支持模糊搜索" v-model="queryParam.content"></Input>
            </Form-item>
          </Col>

          <!-- 第五行：是否完结 -->
          <Col :xs="24" :sm="12" :md="8" :lg="3">
            <Form-item label="是否完结">
              <Select v-model="queryParam.completed" placeholder="全部" @on-change="search" clearable>
                <Option value='0'>否</Option>
                <Option value='1'>是</Option>
              </Select>
            </Form-item>
          </Col>

          <!-- 第六行：反馈人 -->
          <Col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="反馈人" prop="creator">
              <Input name="creator" placeholder="ID、名字" v-model="queryParam.creator"></Input>
            </Form-item>
          </Col>

          <!-- 按钮行 -->
          <Col :xs="24" :sm="12" :md="8" :lg="3">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>

    <List ref="dataList" :tableColumns="title" :reload="reload" :reloadWithPage="reloadWithPage"
          listUrl="/stageReport/fm-message-list" class="pay-list"
          :params="queryParam" :onLoading="onLoading"></List>

    <LessonFeedbackDealModal :feedBackParamData="feedBackParamData" :successCallback="search" :timeList="timeList"
                   v-model="showLessonFeedbackDealModal"></LessonFeedbackDealModal>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId"
                    :successCallback="searchWithPage"></tch-info-modal>
    <AddClassRequirementModal :uid="currentUid" :studentName="currentStudentName"
                   :tchId="currentTchId" :tchName="currentTchName"
                   :successCallback="search"
                   v-model="showAddClassRequirementModal"></AddClassRequirementModal>
  </div>
</template>
<script>
import TchInfoModal from './modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import LessonFeedbackDealModal from '../lesson/modal/LessonFeedbackDealModal.vue'
import AddClassRequirementModal from './modal/AddClassRequirementModal.vue'

export default {
  components: {
    TchInfoModal,
    LessonFeedbackDealModal,
    AddClassRequirementModal
  },
  data () {
    let $moment = this.$moment
    let $constant = this.$constant
    let self = this
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      tchId: null,
      dateRange: '',
      queryParam: {
        creator: '',
        tchId: '',
        tchName: '',
        content: '',
        startDate: '',
        endDate: '',
        completed: '0',
        auditStatus: '',
        bizTypes: ['体验课上课要求']
      },
      showLessonFeedbackDealModal: false,
      feedBackParamData: {},
      timeList: [],
      showAddClassRequirementModal: false,
      currentUid: null,
      currentStudentName: '',
      currentTchId: null,
      currentTchName: '',
      title: [
        {
          title: '反馈人',
          width: 80,
          align: 'center',
          key: 'fromUser'
        },
        {
          title: '反馈时间',
          width: 120,
          align: 'center',
          key: 'createTime',
        },
        {
          title: '标签',
          key: 'feedContent',
          width: 500,
          align: 'center',
          render: (h, params) => {
            let feedContent = params.row.feedContent
            if (feedContent && feedContent.includes('|')) {
                // 按竖线分割内容
              const parts = feedContent.split('|')
              const secondPart = parts[1] // 第二部分作为标签

                // 解析第二部分的标签 (去除方括号、引号并按逗号分割)
              let tags = []
              if (secondPart) {
                  // 移除方括号和引号并按逗号分割
                let tagsString = secondPart.replace(/[[\]"']/g, '') // 移除方括号和引号
                if (tagsString.trim()) {
                  tags = tagsString.split(',').map(tag => tag.trim()).filter(tag => tag)
                }
              }
                // 创建渲染元素数组
              const children = []

                // 添加标签
              if (tags.length > 0) {
                  // 定义不同类型的标签颜色，使用高对比度颜色确保清晰可见
                const tagColors = ['green', 'orange', 'red', 'blue', 'purple']

                const tagElements = tags.map((tag, index) => {
                  return h('Tag', {
                    props: {
                      color: tagColors[index % tagColors.length],
                      closable: false
                    },
                    style: {
                      margin: '2px 5px 2px 0',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }
                  }, tag)
                })
                children.push(h('div', {
                  style: 'display: flex; flex-wrap: wrap; align-items: center;'
                }, tagElements))
              }
              return h('div', children)
            } else {
                // 如果没有竖线，直接显示内容
              return h('span', feedContent)
            }
          }
        },
        {
          title: '其他反馈内容',
          key: 'feedContent',
          width: 300,
          align: 'center',
          render: (h, params) => {
            let feedContent = params.row.feedContent
            if (feedContent && feedContent.includes('|')) {
                // 按竖线分割内容
              const parts = feedContent.split('|')
              const firstPart = parts[0] // 第一部分直接展示
                // 创建渲染元素数组
              const children = []
                // 添加第一部分内容
              if (firstPart) {
                children.push(h('div', { style: 'margin-bottom: 5px;' }, firstPart))
              }
              return h('div', children)
            } else {
                // 如果没有竖线，直接显示内容
              return h('span', feedContent)
            }
          }
        },
        {
          title: '学生 ID、名称',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let uid = params.row.uid
            let stdName = params.row.stdName
            let str = '-'
            if (uid) {
              str = uid + '-' + stdName
            }
            if (str === '-') {
              return h('span', '-')
            } else {
              return h('div', [
                h('a', {on: {click: () => this.openInfoModal(uid)}}, uid + '-' + stdName)
              ])
            }
          }
        },
        {
          title: '老师 ID、名称',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.tchId) {
              return renderTchNameWithScore(h, {
                text: row.tchId + '-' + row.tchName,
                score: row.monthRankScore,
                onClick: () => this.openTchInfoModal(row.tchId)
              })
            } else {
              return h('span', '-')
            }
          }
        },
        {
          title: '上课时间',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {on: {click: () => this.openLessonList(params.row.bookLessonOpenedId)}}, params.row.lessonTime)
            ])
          }
        },
        {
          title: 'sc/cc',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let scName = params.row.scName
            let ccName = params.row.ccName
            return h('div', [
              h('div', scName || '-'),
              h('div', ccName || '-')
            ])
          }
        },
        {
          title: '是否完结',
          width: 70,
          align: 'center',
          key: 'completed',
          render: (h, params) => {
            let completed = params.row.completed
            let completedEnum = $constant.getEnum($constant.yesOrNo, completed)
            return h('span', completedEnum && completedEnum.text)
          }
        },
        {
          title: '老师是否收到',
          key: 'received',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let received = params.row.received
            let receivedEnum = $constant.getEnum($constant.yesOrNo, received)
            return h('span', receivedEnum && receivedEnum.text)
          }
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 120,
          render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
              },
            }, [
              h(
                'a',
                {
                  on: {
                    click: () => {
                      if (params.row.completed) {
                        return
                      }
                      this.handleEnd(params.row)
                    },
                  },
                  style: {
                    color: params.row.completed ? 'gray' : '#2d8cf0',
                  },
                },
                '完结'
              ),
            ])
          }
        }
      ]
    }
  },
  created: function () {
  },
  methods: {
    dateRangeChange (value) {
      if (value && value.length === 2) {
        this.queryParam.startDate = value[0]
        this.queryParam.endDate = value[1]
      } else {
        this.queryParam.startDate = ''
        this.queryParam.endDate = ''
      }
    },
    openLessonList (val) {
      let {href} = this.$router.resolve({
        name: 'bookLessonOpenedList',
        query: {bookLessonOpenedId: val, pageIndex: 1, pageSize: 10}})
      window.open(href, '_blank')
    },
    openInfoModal (val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookUserLeaveTimeList'}})
      window.open(href, '_blank')
    },
    startDateChange (value) {
      this.queryParam.startDate = value
    },
    endDateChange (value) {
      this.queryParam.endDate = value
    },
    openTchInfoModal (val) {
      this.tchId = val
      this.showTchInfoModal = true
    },
    closeModal (val) {
      this.uid = null
      this.editUser = val
    },
    search () {
      this.reload = new Date().getTime()
    },
    searchWithPage () {
      this.reloadWithPage = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    if (!loading) {
      this.loadMonthRankScores()
    }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },
    handleEnd (row) {
      this.$http.post(`/stageReport/fm-message-completed?id=${row.id}`).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('完结成功')
          this.search()
        } else {
          this.$Message.error('完结失败')
        }
      })
    },
    addClassRequirement () {
      // 从路由参数获取学生信息
      const uid = this.$route.query.uid
      const studentName = this.$route.query.studentName || ''

      if (!uid) {
        this.$Message.warning('请先选择学生')
        return
      }

      this.currentUid = uid
      this.currentStudentName = studentName
      // 如果是从课程列表跳转过来，可能有老师信息
      this.currentTchId = this.$route.query.tchId || null
      this.currentTchName = this.$route.query.tchName || ''
      this.showAddClassRequirementModal = true
    }
  },
  watch: {}
}
</script>

<style scoped>
.margin {
  padding-left: 15px;
  margin-bottom: 10px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}

.bg {
  background-color: red;
}
.btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// TrialLessonRequirements.vue?76b62674